import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react";
import SweetAlert from "react-bootstrap-sweetalert"
import { useTranslation } from 'react-i18next'

export const ModalConfirm = ({ title, description, timer, onConfirm, onCancel, confirmStyle, cancelStyle, customButtons, confirmText, cancelText }) => {
    const { t } = useTranslation();
    const [counter, setCounter] = useState(timer); // Establece aquí el valor inicial del contador
    const [confirmDisabled, setConfirmDisabled] = useState(true);

    useEffect(() => {
        let interval;
        interval = setInterval(() => {
            setCounter((prevCounter) => prevCounter - 1);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        setConfirmDisabled(counter > 0);
    }, [counter]);

    const confirmTxt = confirmText || t("buttons.yes");
    const cancelTxt = cancelText || t("buttons.no");

    return (
        <SweetAlert
            warning
            title={title}
            onConfirm={onConfirm}
            onCancel={onCancel}
            confirmBtnBsStyle={confirmStyle}
            cancelBtnBsStyle={cancelStyle}
            confirmBtnText={counter > 0 ? `${confirmTxt} (${counter})` : confirmTxt}
            cancelBtnText={cancelTxt}
            showCancel
            disabled={confirmDisabled} // Deshabilita el botón de confirmación según el estado del contador
            customButtons={customButtons}
        >
            {description}
        </SweetAlert>
    );
}

ModalConfirm.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    timer: PropTypes.number,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string
};

ModalConfirm.defaultProps = {
    timer: 3,
    confirmStyle: "success",
    cancelStyle: "info",
    customButtons: null,
    confirmText: null,
    cancelText: null
};